;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_YELLOW_COLOR_BUTTON,
  UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
} from "../../../../src/lib/constants"

const CustomButton = styled(Button)(() => ({
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
  backgroundColor: UI_STYLE_YELLOW_COLOR_BUTTON,
  boxShadow: "none",
  height: "52px",
  width: "188px",
  display: "flex",
  justifyContent: "space-around",
  padding: "0 15px",
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "19px",
  textTransform: "unset",
  textAlign: "center",
  letterSpacing: "0.03em",
  borderRadius: "100px",
  fontFamily: "var(--font-roboto)",
  "@media only screen and (min-width: 600px)": {
    fontSize: "16px",
    width: "213px",
  },
  "&:hover": {
    backgroundColor: UI_STYLE_YELLOW_COLOR_BUTTON_PUSHED,
  },
}))

type PrimaryCTAButtonProps = {
  text: string
  href: string
}

export default function PrimaryCTAButton({ text, href }: PrimaryCTAButtonProps) {
  const isValidUrl = (url: string) => {
    try {
      new URL(url)
      return true
    } catch {
      return false
    }
  }

  const fixMalformedUrl = (url: string) => {
    if (url && url.startsWith("https://blog/")) {
      return `https://getzestlife.com/blog/${url.replace("https://blog/", "")}`
    }
    if (url && url === "https://blog") {
      return "https://getzestlife.com/blog"
    }
    return url
  }

  const processedHref = fixMalformedUrl(href)
  const isValid = isValidUrl(processedHref)

  if (!isValid || !processedHref) {
    return (
      <CustomButton>
        <div>{text}</div>
      </CustomButton>
    )
  }

  if (
    processedHref.startsWith("http") &&
    !processedHref.includes("getzestlife.com")
  ) {
    return (
      <CustomButton
        {...({
          href: processedHref,
          target: "_blank",
          rel: "noopener noreferrer",
        } as React.ComponentProps<typeof Button>)}
      >
        <div>{text}</div>
      </CustomButton>
    )
  }

  return (
    <CustomButton
      {...({ href: processedHref } as React.ComponentProps<typeof Button>)}
    >
      <div>{text}</div>
    </CustomButton>
  )
}
